import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ServerUnavailableService } from './server-unavailable.service';

@Component({
  selector: 'enrich-server-unavailable',
  templateUrl: './server-unavailable.page.html',
  styleUrls: ['./server-unavailable.page.sass'],
  encapsulation: ViewEncapsulation.None,
})
export class ServerUnavailablePage implements OnInit {
  logMessages: string[] = [];

  constructor(
    private serverUnavailableService: ServerUnavailableService,
  ) { }

  ngOnInit() {
    this.serverUnavailableService.feed().subscribe(message => {
      this.logMessages.push(message);
    });

    this.serverUnavailableService.dumpEnvironment();
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/errors/server-unavailable/server-unavailable.page.ts